import { GoalsList } from "@/App/Goals/Table";
import { useAuth } from "@/hooks/auth";
import { TypeUser } from "@/types/userType";
import { NotFound } from "@/pages/NotFound";
import { usePermissions } from "@/hooks/usePermissions";

export function PageList() {
  const { user } = useAuth();
  const { hasPermission } = usePermissions();
  const userTypeId = user?.user_type?.id;

  // Verifica se é cliente E tem permissão para ver metas
  if (userTypeId !== TypeUser.client || !hasPermission("view-goals-list")) {
    return <NotFound />;
  }

  return <GoalsList />;
}
